import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import closeIcon from '../../Assets/Icons/close.svg';
import termsData from './term&condition.json';
import { useMsal } from '@azure/msal-react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContributorFormPopup = ({ contributor, setContributor }) => {
    const { accounts } = useMsal();
    const [employeeData, setEmployeeData] = useState(null);

    useEffect(() => {
        const userEmail = accounts[0].username?.toLowerCase();
        if (userEmail) {
            fetch(`https://prod.appstudioltts.com/api/empdata/employees/${userEmail}`)
                .then((response) => response.json())
                .then((data) => {
                    setEmployeeData(data);
                })
                .catch((error) => {
                    console.error("Error fetching employee data:", error);
                });
        }
    }, [accounts]);

    const { register, handleSubmit, watch, formState: { errors }, reset } = useForm();

    const isChecked = watch('agree', false);
    const primarySkill = watch('primarySkill', '');
    const secondarySkill = watch('secondarySkill', '');

    const isFormValid = primarySkill && secondarySkill && isChecked && employeeData;

    const onSubmit = async (data) => {
        const user = accounts[0];
        const userEmail = user.username;
        const userName = user.name;

        if (!employeeData) {
            console.error("Employee data not available");
            return;
        }

        const dataToSend = {
            primary_skills: data.primarySkill,
            secondary_skills: data.secondarySkill,
            SenderName: userName,
            Email: userEmail,
            DeliveryUnit: employeeData.DeliveryUnit,
            DeliveryGroup: employeeData.DeliveryGroup,
        };

        try {
            const skillsResponse = await fetch(
                "https://prod.appstudioltts.com/api/skills/skillsupdate",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataToSend),
                }
            );

            if (skillsResponse.ok) {
                const emailResponse = await fetch(
                    `https://prod.appstudioltts.com/api/skillupdate-mail/send-email`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ email: userEmail }),
                    }
                );

                if (emailResponse.ok) {
                    console.log("Email sent successfully!");
                } else {
                    console.error("Failed to send email.");
                }


                toast.success("Data sent successfully!");
                reset();
                setContributor(false);
            } else {
                console.error("Failed to submit skills data.");
            }
        } catch (error) {
            console.error("Error submitting approval request:", error);
        }
    };


    const handleClose = () => {
        setContributor(false);
    };

    const handleCancel = () => {
        setContributor(false);
    };

    // Loader while fetching employee data
    if (!employeeData) {
        return (
            <div className='flex justify-center items-center bg-opacity-50 bg-black h-full'>
                <div className='text-white text-lg font-semibold'>Loading employee data...</div>
            </div>
        );
    }

    return (
        <div className='flex justify-center items-center bg-opacity-50 bg-black h-full rounded-md'>
            <ToastContainer />
            <div className='w-[85%] bg-white p-4  rounded-md'>
                <div className='flex w-full bg-white justify-between p-4 pl-0 border-b-2'>
                    <div className='font-bold'>Enter Your Skills</div>
                    <div>
                        <img
                            src={closeIcon}
                            alt='Close'
                            className='w-[32px] h-8 cursor-pointer'
                            onClick={handleClose}
                        />
                    </div>
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='flex w-full gap-6 border-b-2 pb-4 pt-2'>
                        <div className='flex flex-col w-[40%]'>
                            <label className='pb-2'>Select Primary Skills</label>
                            <input
                                {...register('primarySkill', { required: 'Primary skill is required' })}
                                type='text'
                                className="border-2 rounded-md w-full p-2 focus:outline-none focus:border-sky-500"
                                placeholder='Enter your primary skill'
                            />
                            {errors.primarySkill && (
                                <span className="text-red-500">{errors.primarySkill.message}</span>
                            )}
                        </div>
                        <div className='flex flex-col w-[40%]'>
                            <label className='pb-2'>Select Secondary Skills</label>
                            <input
                                {...register('secondarySkill', { required: 'Secondary skill is required' })}
                                type='text'
                                className="border-2 rounded-md w-full p-2 focus:outline-none focus:border-sky-500"
                                placeholder='Enter your secondary skill'
                            />
                            {errors.secondarySkill && (
                                <span className="text-red-500">{errors.secondarySkill.message}</span>
                            )}
                        </div>
                    </div>

                    <div className='flex flex-col'>
                        <h1 className='text-blue-700 font-bold pt-5 pb-3'>Terms and Conditions</h1>
                        <ul className='pl-8'>
                            {termsData.terms?.map((item, index) => (
                                <li key={index} className='list-disc'>{item.term}</li>
                            ))}
                        </ul>
                        <div className='flex gap-3 pt-5 items-center'>
                            <input
                                {...register('agree', { required: 'You must agree to the terms' })}
                                type='checkbox'
                                className='accent-[#005dff]'
                            />
                            <label>I agree to the terms and conditions</label>
                            {errors.agree && (
                                <span className="text-red-500">{errors.agree.message}</span>
                            )}
                        </div>
                    </div>

                    <div className='w-full flex justify-end gap-6 pt-6'>
                        <button
                            type="button"
                            className='p-2 w-[15%] border-[#005dff] border text-[#005dff]'
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={`p-2 w-[20%] border-2 text-white rounded-md ${isFormValid ? 'bg-[#005dff]' : 'bg-[#add8e6]'}`}
                            disabled={!isFormValid}
                        >
                            Submit for Approval
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ContributorFormPopup;
